export var placemnet;
(function (placemnet) {
    placemnet["LEFT"] = "left";
    placemnet["RIGHT"] = "right";
    placemnet["CENTER"] = "center";
})(placemnet || (placemnet = {}));
